// extracted by mini-css-extract-plugin
export default {"Contact_box_form":"ContactsForm_Contact_box_form__6HPez","Contact_submit_btn":"ContactsForm_Contact_submit_btn__WwuLs"};